// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    // Templates list
    setUpNow: {
        id: 'actions.set-up-now',
        defaultMessage: 'Set up now'
    },
    // Template Description
    continue: {
        id: 'actions.continue',
        defaultMessage: 'Continue'
    },
    thisActionUses: {
        id: 'actions.this-action-uses',
        defaultMessage: 'This actions uses',
        description: 'Listing all attributes used by the actions (e.g. devices, dark)'
    },
    deviceRequired: {
        id: 'actions.device-required',
        defaultMessage: 'Required'
    },
    hiveLiveRequired: {
        id: 'actions.hiveLiveRequired',
        defaultMessage: 'Hive Live required'
    },
    hubRequiredTitle: {
        id: 'actions.hub-required-title',
        defaultMessage: 'Hive hub is required'
    },
    hubRequiredDescription: {
        id: 'actions.hub-required-description',
        defaultMessage: 'Actions is one of many new and upcoming smart features that needs our Hub to work.'
    },
    findOutMore: {
        id: 'actions.find-out-more',
        defaultMessage: 'Find out more'
    },
    upgradeHubTitle: {
        id: 'actions.upgrade-hub-title',
        defaultMessage: "It's time to upgrade your Hub"
    },
    upgradeHubContent: {
        id: 'actions.upgrade-hub-content',
        defaultMessage:
            'This is one of many new and upcoming smart features that needs the latest version of our Hub to work. Call us on 0333 202 9618 to get your upgrade.'
    },
    done: {
        id: 'actions.done',
        defaultMessage: 'Done'
    },
    // Filter sections
    browseByCategory: {
        id: 'actions.browse-by-category',
        defaultMessage: 'Browse by category'
    },
    browseByDevice: {
        id: 'actions.browse-by-device',
        defaultMessage: 'Browse by device'
    },
    browseAllActions: {
        id: 'actions.browse-all-actions',
        defaultMessage: 'Browse all Actions'
    },
    buildYourOwn: {
        id: 'actions.build-your-own',
        defaultMessage: 'Build your own'
    },
    // Banner Filter
    bannerTitle: {
        id: 'actions.banner-title',
        defaultMessage: 'Welcome Home'
    },
    bannerDescription: {
        id: 'actions.banner-description',
        defaultMessage: 'Browse the new and powerful actions introduced with Welcome Home subscription.'
    },
    bannerBrowse: {
        id: 'actions.banner-browse',
        defaultMessage: 'BROWSE'
    },
    //
    cancelAttribute: {
        id: 'actions.cancel-attribute',
        defaultMessage: 'Cancel'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/actions/intl.js